// covered-by: frontends/carrie/src/routes/settings/routes/__tests__/EnterpriseSettingsView.test.tsx
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import { EnterpriseSettingsView } from "./EnterpriseSettingsView";

import { isMeaningfulGigsRole, requiresAuth } from "../../../utils/auth";
import { authLayoutRoute } from "../../auth-layout/route";
import { ticketsRoute } from "../../tickets/route";

export const enterpriseSettingsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "enterprise-settings",
  beforeLoad() {
    requiresAuth();
    if (!isMeaningfulGigsRole()) {
      throw redirect({ to: ticketsRoute.to } as never);
    }
  },
  component: EnterpriseSettingsView,
});
